// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1QNm9","colCheckbox":"styles_colCheckbox__30x2j"};